export const GOOGLE_SERVICE_PROVIDERS = ['ga4', 'gsc', 'gbp'];

export function buildIntegrationConnections({
  oauthConnections = {},
  googleStatus = {},
  cmsStatus = null,
} = {}) {
  const merged = Object.entries(oauthConnections || {}).reduce((acc, [provider, connection]) => {
    if (provider !== 'google') {
      acc[provider] = connection;
    }
    return acc;
  }, {});

  GOOGLE_SERVICE_PROVIDERS.forEach((provider) => {
    const service = googleStatus?.[provider];
    if (service?.status === 'connected') {
      merged[provider] = {
        provider,
        is_active: true,
        connected_email: service.google_email || '',
        connected_at: service.connected_at,
      };
    }
  });

  if (
    cmsStatus
    && cmsStatus.platform
    && cmsStatus.platform !== 'none'
    && cmsStatus.status === 'connected'
  ) {
    merged[cmsStatus.platform] = {
      provider: cmsStatus.platform,
      is_active: true,
      connected_email: cmsStatus.site_url || '',
      connected_at: cmsStatus.connected_at,
    };
  }

  return merged;
}

export function isProviderConnected(connections, provider) {
  return connections?.[provider]?.is_active === true;
}
